var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBill05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 104,
    viewBox: "0 0 74 104",
    width: 74,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m73.7344.0857544h-73.7344v103.9142456h73.7344z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m72.6333 1.18714v101.71186h-71.53192v-101.71186zm1.1013-1.1013856h-73.7346v103.9142456h73.7344v-103.9142456z",
    fill: "#989ba2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 23.2779h-67.36745v4.3727h67.36745z",
    fill: "#c9c9e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m73.7344 0h-73.7344v4.37269h73.7344z",
    fill: "#989ba2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 88.1561h-67.36745v10.7201h67.36745z",
    fill: "#e3e3e3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m70.5022 19.6598h-8.4407v-11.79777h8.4407v11.79747zm-8.2176-.223h7.9945v-11.35171h-7.9945z",
    fill: "#989ba2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m62.2844 19.6598h-8.4406v-11.79777h8.4406v11.79747zm-8.2176-.223h7.9946v-11.35171h-7.9946z",
    fill: "#989ba2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m5.76481 11.7557c-.10531 1.328-.42067 2.1235-2.12348 2.5377-.05266-.1577-.21034-.4077-.33518-.526 1.52502-.3156 1.74216-.9268 1.82765-2.0117zm.20383-2.3601h-2.50481v-.56534h2.50481v-.57864h.63101v.57864h2.57048v.56534h-2.57048v.55883h1.97882v.53897h-4.50315v-.53897h1.89332zm2.44564 2.8465v-.7627h-4.22063v.7627h-.59817v-1.3082h5.4368v1.3082zm0 1.3738c.23016 0 .27602-.0985.29584-.8085.12484.0985.38132.1905.55231.2302-.06567.9073-.23015 1.1372-.78898 1.1372h-.90732c-.66384 0-.82833-.1775-.82833-.7692v-1.6501h.61149v1.6433c0 .1905.04615.2168.29583.2168h.76916z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15.8291 13.3467v.618h-5.88379v-.618h2.39949v-5.00936h.6573v1.95246h2.3732v.6115h-2.3732v2.4457h2.8267z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5179 8.44239c-.1775.44049-.4011.8875-.6443 1.30817v4.50964h-.5787v-3.6289c-.2103.2828-.4272.539-.6443.7626-.0592-.1381-.2367-.4668-.3352-.618.6444-.6047 1.2623-1.55133 1.6304-2.51781l.5718.184zm3.4645 5.83761c-.0462-.1644-.1118-.355-.2038-.5523-1.2425.1184-2.5442.2302-3.4645.3024l-.1119-.618c.2039-.013.434-.0264.6837-.0394.2432-.5981.4997-1.4265.6707-2.1167h-1.2952v-.5916h4.2402v.5916h-2.2484c-.2103.6837-.4866 1.4659-.7363 2.0709.618-.0462 1.3147-.0985 1.9984-.1512-.1905-.342-.4077-.697-.618-1.0058l.539-.2302c.4668.6443.9597 1.4922 1.1307 2.0773l-.5852.263zm.171-4.96343h-3.4119v-.59817h3.4119z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m25.0389 12.9654c-.3813.4863-.986.9466-1.5185 1.2359-.0985-.1053-.3222-.3088-.4535-.4076.5325-.2367 1.0848-.6245 1.407-1.0257l.5653.1974zm3.9245-.802v.4931h-2.6231v1.0058c0 .2894-.0527.447-.2695.526-.2169.092-.526.092-.9795.092-.0264-.1577-.1119-.3878-.1905-.539.3221.013.6179.013.71.0065.092-.0065.1183-.0263.1183-.1053v-.986h-2.6164v-.4931h5.851zm-3.9706-3.18172h-1.7949v-.49315h5.6404v.49315h-1.8212v.43398h1.4922v1.54484h-4.9306v-1.54484h1.4135v-.43398zm-1.0914 2.81362v-.4798h4.273v.4798zm.2497-1.2951h.8414v-.63103h-.8414zm2.2877-1.51852h-.881v.43398h.881zm-.881 1.51852h.881v-.63103h-.881zm1.8143 2.2877c.5195.276 1.1899.6969 1.5449.9993l-.4799.355c-.3156-.2959-.9795-.7429-1.512-1.0387zm-.355-2.91902v.63102h.8875v-.63102z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m8.47004 94.7429h-1.3765v-.4692h1.3765v-.5384h-1.3765v-.4692h1.16883l-1.36882-2.6918h.923l.59995 1.3765c.16152.3769.31536.7615.48457 1.1535h.03846c.17691-.4.33074-.7769.49995-1.1535l.60762-1.3765h.8923l-1.37655 2.6918h1.17655v.4692h-1.38423v.5384h1.38423v.4692h-1.38423v1.338h-.88424v-1.338z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m51.261 19.2693h-48.23805v.5576h48.23805z",
    fill: "#231815"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#989ba2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 34.0692h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 27.6461h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 23.1663h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 40.4923h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 46.9157h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 53.3388h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 59.7619h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 66.1853h-67.36745v.223h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 72.6084h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 79.0315h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.3904 85.4546h-67.36745v.2231h67.36745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.13468 23.2779h-.22306v62.2883h.22306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5766 23.2779h-.2231v62.2883h.2231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.665 23.2779h-.2231v62.2883h.2231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.2094 23.2779h-.2231v62.2883h.2231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.287 27.7577h-.2147v57.8085h.2147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.3686 27.7577h-.2148v57.8085h.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.4501 27.7577h-.2147v57.8085h.2147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.5322 27.7577h-.2148v57.8085h.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.6132 27.7577h-.2148v57.8085h.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.6948 27.7577h-.2148v57.8085h.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.5024 23.2779h-.2231v62.2883h.2231z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m52.3555 32h6v50h-6z",
    fill: "#f00",
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 37.961988 -27.648346)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m56.5981 67.3553h6v50h-6z",
    fill: "#f00",
    transform: "matrix(-.70710678 .70710678 -.70710678 -.70710678 144.24639 74.961789)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBill05);
export default __webpack_public_path__ + "static/media/img-bill05.a2a10d483bef2de29e54ce9d3c9a5200.svg";
export { ForwardRef as ReactComponent };